import { useAppSelector } from "@hooks/store"
import { getChargeDebtorTemplate } from "@pages/collectionAdministration/pages/NewEditTemplateCollection/services/GET/getChargeDebtorTemplate"
import { useDebounce } from "@thooks/useDebounce"
import { useCallback, useEffect, useState } from "react"

export const useUsersModal = ({ debtors, handleModalClose }) => {
    const { idToken } = useAppSelector(state => state.auth)
    const [loadingUsersModal, setLoadingUsersModal] = useState(false)
    const [currentDebtors, setCurrentDebtors] = useState(debtors)
    const [selectedPlaces, setSelectedPlaces] = useState([])

    const getChargeDebtorTemplateService = useCallback(async ({ setLoading, selectedPlaces }) => {
        setLoading?.(true)
        try {
            //Se obtiene el blob del archivo
            const blobFile = await getChargeDebtorTemplate({ token: idToken, places: selectedPlaces })
            const downloadUrl = window.URL.createObjectURL(blobFile)

            const link = document.createElement('a')
            link.href = downloadUrl
            link.download = 'Plantilla de cobros.xlsx'
            link.click()

            setTimeout(() => {
                window.URL.revokeObjectURL(downloadUrl)
            }, 1000)

            return blobFile
        } catch (error) {
            setLoading?.(false)
            console.error(error)
            return []
        }
    }, [idToken])

    const handleSelectPlace = ({ value }) => {
        const prevSelectedPlaces = [...selectedPlaces]
        const index = prevSelectedPlaces.findIndex((item) => item === value)
        if (index === -1) {
            prevSelectedPlaces.push(value)
            return setSelectedPlaces(prevSelectedPlaces)
        }
        const newSelectedPlaces = prevSelectedPlaces.filter((item) => item !== value)
        return setSelectedPlaces(newSelectedPlaces)

    }

    const debounceSearchPlace = useDebounce(({ value }) => {
        const newDebtors = debtors.filter((item) => item.owner_name.toLowerCase().includes(value.toLowerCase()) ||
            item.place_name.toLowerCase().includes(value.toLowerCase()))
        return setCurrentDebtors(newDebtors)
    }, 300)

    const handleSearchPlace = ({ value }) => {
        debounceSearchPlace({ value })
    }

    const handleCheckAllPlaces = () => {
        if (selectedPlaces.length !== debtors.length) {
            return setSelectedPlaces(debtors.map((item) => item.place_id))
        }
        return setSelectedPlaces([])
    }

    const handleDownloadTemplateWithSelectedUsers = async () => {
        await getChargeDebtorTemplateService({ setLoading: setLoadingUsersModal, selectedPlaces })
        setLoadingUsersModal?.(false)
        setSelectedPlaces([])
        //Cerrar el modal
        handleModalClose({ isOpenModal: false })
    }

    useEffect(() => {
        setCurrentDebtors(debtors)
    }, [debtors])

    return {
        currentDebtors,
        selectedPlaces,
        loadingUsersModal,
        setCurrentDebtors,
        handleSelectPlace,
        handleSearchPlace,
        handleCheckAllPlaces,
        handleDownloadTemplateWithSelectedUsers
    }
}